import { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const LABEL = { awaiting_conditional: "Waiting on vendor's conditional waiver", conditional_signed: "Ready to pay",
  paid_awaiting_unconditional: "Paid · waiting on unconditional waiver", closed: "Closed · both waivers signed" };

export const LienWaiversPanel = () => {
  const [rows, setRows] = useState(null);
  const [msg, setMsg] = useState({});
  const load = useCallback(() => {
    fetch(`${API}/api/admin/lien-waivers`, { credentials: "include" }).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((j) => setRows((j.waivers || []).filter((w) => !/^TEST/i.test(w.project || "")))).catch(() => setRows([]));
  }, []);
  useEffect(load, [load]);
  const pay = async (w) => {
    if (!window.confirm(`Mark $${w.amount_usd.toLocaleString()} (${w.milestone_label}) to ${w.payee} as paid?`)) return;
    const r = await fetch(`${API}/api/admin/lien-waivers/${w.waiver_id}/mark-paid`, { method: "POST", credentials: "include" });
    const j = await r.json().catch(() => ({}));
    setMsg((m) => ({ ...m, [w.waiver_id]: r.ok ? "Marked paid" : j.detail || "Could not update" }));
    if (r.ok) load();
  };
  if (!rows) return <div className="rr-muted" data-testid="lien-waivers-loading">Loading lien waivers…</div>;
  return (
    <div className="rr-bids" data-testid="lien-waivers-panel">
      <div className="rr-bids__title">Lien waivers · every job and payment</div>
      {rows.length === 0 && <div className="rr-muted" data-testid="lien-waivers-empty">No lien waivers yet. They're created when you accept a bid.</div>}
      {rows.map((w) => (
        <div key={w.waiver_id} className="rr-bid" data-testid={`lien-row-${w.waiver_id}`}>
          <div><b>{w.payee}</b> · {w.work_order_id} · {w.project}</div>
          <div>{w.milestone_label} · ${w.amount_usd.toLocaleString()}</div>
          <span data-testid={`lien-status-${w.waiver_id}`}>{LABEL[w.status]}</span>
          {w.status === "conditional_signed" && <button type="button" onClick={() => pay(w)} data-testid={`lien-mark-paid-${w.waiver_id}`}>Mark paid</button>}
          {msg[w.waiver_id] && <span data-testid={`lien-msg-${w.waiver_id}`}>{msg[w.waiver_id]}</span>}
        </div>
      ))}
    </div>
  );
};
